import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const ChevronUp_md = (props) => {
    const width = props.width ? props.width + 'px' : '24px';
    const height = props.height ? props.height + 'px' : '24px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 24 24"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.7474 16.6644C21.3805 17.0771 20.7484 17.1143 20.3356 16.7474L12 9.33795L3.66435 16.7474C3.25157 17.1143 2.6195 17.0771 2.25258 16.6644C1.88566 16.2516 1.92284 15.6195 2.33563 15.2526L11.3356 7.25259C11.7145 6.9158 12.2855 6.9158 12.6644 7.25259L21.6644 15.2526C22.0771 15.6195 22.1143 16.2516 21.7474 16.6644Z"
            />
        </SvgStyled>
    );
};

export default ChevronUp_md;
